import { Station } from "oneclick-component/src/store/apis/enhancedApi";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";

const useMeUserStation = (): Station | null => {
  return useSelector((state: RootState) => state.auth.meUser?.station ?? null);
};

export default useMeUserStation;
